import { apiUrl } from '../config/api'

export async function translateText(text, to = 'en') {
  const params = {
    text,
    to
  }

  let url = apiUrl('Translate')

  const data = await sendReq(params, url)

  return data?.[0]?.translations?.[0]?.text ?? ''
}

async function sendReq(params, url) {
  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json'
    }
  }).catch((error) => {
    console.error('Translate request failed:', error)
    throw new Error('translation_failed')
  })

  if (!res || !res.ok) {
    throw new Error('translation_failed')
  }

  return await res.json()
}
